import { useEffect, useState } from "react"

import { mixpanelClient } from "services/mixpanel/mixpanel"

declare global {
  interface Window {
    Kustomer?: {
      start: (
        config: {
          brandId: string
          hideChatIcon?: boolean
        },
        callback?: () => void,
      ) => void
      open: () => void
      isChatAvailable: () => boolean
      addListener: (event: string, callback: () => void) => void
      removeListener: (event: string, callback: () => void) => void
    }
  }
}

// <script
//       src="https://cdn.kustomerapp.com/chat-web/widget.js"
//       data-kustomer-api-key="eyJhbGciOiJub25lIn0.eyJvcmciOiI2MjNjNmY0Yzg5MDEzMGNkYWNkNGM2Y2EiLCJvcmdOYW1lIjoid2hpbXN0YXkiLCJwb2QiOiJwcm9kMSIsInJvbGVzIjpbIm9yZy50cmFja2luZyJdfQ."

//       ></script>
//     <script async>
//       Kustomer.start({
//         brandId: "623c6f4f547d385ab960dc35",
//       })
//     </script>

const KustomerChat = () => {
  const [isKustomerLoaded, setIsKustomerLoaded] = useState(false)
  const [isChatOpen, setIsChatOpen] = useState(false)

  const onOpenHandler = () => {
    setIsChatOpen(true)
  }

  const onCloseHandler = () => {
    setIsChatOpen(false)
  }

  useEffect(() => {
    // Check if the script is already added
    if (!document.getElementById("kustomer-chat-script")) {
      const script = document.createElement("script")
      script.id = "kustomer-chat-script"
      script.src = "https://cdn.kustomerapp.com/chat-web/widget.js"
      script.async = true
      script.setAttribute(
        "data-kustomer-api-key",
        process.env.REACT_APP_KUSTOMER_API_KEY || "",
      )
      script.onload = () => {
        // Initialize Kustomer Chat once the script loads
        if (window.Kustomer) {
          window.Kustomer.start(
            {
              brandId: process.env.REACT_APP_KUSTOMER_BRAND_ID || "",
              hideChatIcon: true,
            },
            () => {
              window.Kustomer?.addListener("onOpen", onOpenHandler)
              window.Kustomer?.addListener("onClose", onCloseHandler)
              setIsKustomerLoaded(true)
            },
          )
        }
      }
      document.body.appendChild(script)
    }
    // Optional: Cleanup if the component unmounts
    return () => {
      const script = document.getElementById("kustomer-chat-script")
      if (script) {
        script.remove()
      }
      if (window.Kustomer) {
        window.Kustomer?.removeListener("onOpen", onOpenHandler)
        window.Kustomer?.removeListener("onClose", onCloseHandler)
      }
    }
  }, [])

  const handleChatClick = () => {
    // Mixpanel event on Help
    mixpanelClient.RBO_SUPPORT_CLICKED()

    if (window.Kustomer && window.Kustomer.isChatAvailable()) {
      window?.Kustomer?.open()
    } else {
      console.error("Kustomer is not loaded yet.")
    }
  }

  return isKustomerLoaded && !isChatOpen ? (
    <button
      type='button'
      onClick={handleChatClick}
      className='kustomer-chat-button'
    >
      Need Help?{" "}
      <svg width='19px' height='18px' viewBox='0 0 19 20' fill='none'>
        <path
          d='M9.34451 0.25C14.3971 0.25 18.4927 4.2521 18.4927 9.18924C18.4927 14.1264 14.3971 18.1285 9.34451 18.1285H2.02593C1.54068 18.1285 1.0753 17.9401 0.73218 17.6048C0.389055 17.2695 0.196289 16.8148 0.196289 16.3406V9.18924C0.196289 4.2521 4.29195 0.25 9.34451 0.25ZM9.34451 2.03785C7.40351 2.03785 5.542 2.7913 4.1695 4.13244C2.797 5.47359 2.02593 7.29257 2.02593 9.18924V16.3406H9.34451C11.2855 16.3406 13.147 15.5872 14.5195 14.246C15.892 12.9049 16.6631 11.0859 16.6631 9.18924C16.6631 7.29257 15.892 5.47359 14.5195 4.13244C13.147 2.7913 11.2855 2.03785 9.34451 2.03785ZM9.34451 10.9771C9.57768 10.9773 9.80196 11.0646 9.97151 11.221C10.1411 11.3774 10.2431 11.5912 10.2568 11.8186C10.2704 12.0461 10.1947 12.27 10.045 12.4448C9.89537 12.6195 9.68309 12.7318 9.45155 12.7587L9.34451 12.7649H6.60005C6.36688 12.7647 6.14261 12.6774 5.97306 12.521C5.80351 12.3646 5.70148 12.1509 5.68781 11.9234C5.67415 11.6959 5.74988 11.472 5.89953 11.2973C6.04919 11.1225 6.26148 11.0103 6.49301 10.9833L6.60005 10.9771H9.34451ZM12.089 7.40139C12.3316 7.40139 12.5643 7.49557 12.7359 7.66322C12.9074 7.83086 13.0038 8.05823 13.0038 8.29531C13.0038 8.5324 12.9074 8.75977 12.7359 8.92741C12.5643 9.09506 12.3316 9.18924 12.089 9.18924H6.60005C6.35742 9.18924 6.12473 9.09506 5.95317 8.92741C5.78161 8.75977 5.68522 8.5324 5.68522 8.29531C5.68522 8.05823 5.78161 7.83086 5.95317 7.66322C6.12473 7.49557 6.35742 7.40139 6.60005 7.40139H12.089Z'
          fill='white'
        />
      </svg>
    </button>
  ) : null
}

export default KustomerChat
